import { useCallback, useEffect, useState } from 'react';
import { getUserNotifications } from '../network/network_callbacks';
import {
  countUnreadNotifications,
  extractNotificationsFromResponse,
} from '../utils/notificationUtils';

/**
 * Loads unread notification count from GET /user/notifications.
 * Badge shows unique items whose status is not READ.
 */
export function useNotificationUnreadCount(enabled = true) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setUnreadCount(0);
      return 0;
    }

    setLoading(true);
    try {
      const response = await getUserNotifications();
      if (!response) {
        setUnreadCount(0);
        return 0;
      }

      const { items } = extractNotificationsFromResponse(response);
      const count = countUnreadNotifications(items);
      setUnreadCount(count);
      return count;
    } catch (error) {
      console.error('Failed to load notification count:', error);
      return 0;
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const clear = useCallback(() => {
    setUnreadCount(0);
  }, []);

  return { unreadCount, loading, refresh, clear };
}
